module.exports = __webpack_public_path__ + "assets/d264fc3bfe78b9acf3d4bce53af41961.png";